<template>
  <MainLayout>
    <BackButton text="Back to Project" :route="$routes.project(projectId)" />

    <v-container max-width="1000" v-if="pythonErrors">
      <v-alert type="error" icon="fas fa-warning" variant="tonal">
        <p>
          There were problems during the analysis and it could not be performed. If you think that this is a mistake
          please contact the developers.
        </p>
        <br>
        <b>Error Message:</b>
        {{ pythonErrors.errors }}
      </v-alert>
    </v-container>

    <v-container v-else max-width="1000">
        <h2 class="text-center">PPI Analysis </h2>
        <v-row justify="center" class="mt-5">
          <v-col cols="12">
            <v-card class="pa-5" elevation="1">
              <SimpleVerticalBarChart
                v-if="callImpactData && callImpactData.labels.length > 0"
                :chartData="callImpactData"
                :gradientColors="callImpactGradientColors"
                :axisLabels="{ x: 'Call Impact Id', y: 'Call Impact Score' }"
                :title="`Call Impact Data`"
                id="Call Impact"/>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="mb-3">
            <v-card class="pa-5" elevation="1">
              <SimpleBarChart
                  v-if="psisData"
                  :chartData="psisData"
                  :annotations="annotations"
                  :gradientColors="psisGradientColors"
                  :averageValue="averageValue"
                  title="PSIs Scores"
                  :axisLabels="{ x: 'Score', y: '' }"
                  :key="`bar_key_${horizontalBarKey}`"
                  id="PSIs Scores" />
            </v-card>
          </v-col>
        </v-row>
    </v-container>
  </MainLayout>
</template>

<script setup>
import MainLayout from "../../Layouts/Main.vue";
import SimpleBarChart from "../../Charts/simple/SimpleBarChart.vue";
import SimpleVerticalBarChart from "../../Charts/simple/SimpleVerticalBarChart.vue";
import {Link, router} from "@inertiajs/vue3";
import { computed, onMounted } from "vue";
import Utils from "@/Mixins/Utils";
import { ref } from "vue";
import * as $routes from "@/packs/routes";
import BackButton from "@/Shared/BackButton.vue";

const props = defineProps({
  result: {
    type: Object,
    required: false,
  },
  callImpactData: {
    type: Object,
    required: false,
  },
  callImpactGradientColors: {
    type: Array,
    required: false,
  },
  psisData: {
    type: Object,
    required: false,
  },
  averageValue: {
    type: Number,
    required: false,
    default: null,
  },
  psisGradientColors: {
    type: Array,
    required: false,
  },
  projectId: {
    type: Number,
    required: true,
  },
  pythonErrors: {
    type: Object,
    required: false,
  },
});

const horizontalBarKey = ref(1);

/* Calculates the average value of the PSI scores. */
const psiScoresMean = computed(() => {
  const data = props.psisData.datasets[0].data
  return data.reduce((a, b) => a + b) / data.length
})

/* Constructs the annotations to be added on the PSI scores chart. */
const annotations = computed(() => {
  const result = []
  result.push({ label: 'PPI', value: props.averageValue })
  result.push({ label: 'Average', value: psiScoresMean.value })

  return result
})

</script>

<style scoped></style>
